import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import { ListItem } from 'framework/list';

interface EditSkillBasedQueueButtonProps extends EditButtonProps {
  isVisible?: (data: ListItem) => boolean;
}

const EditSkillBasedQueueButton = (props: EditSkillBasedQueueButtonProps) => {
  const { getUpdateEntityUrl } = useSkillBasedQueueUrl();

  return <EditButton {...props} path={getUpdateEntityUrl} />;
};

export default EditSkillBasedQueueButton;
